export default {
  ourLetter: "La nostra lettera",
  restaurantIsClosed: "Il ristorante è chiuso",
  isANewProduct: "È un nuovo prodotto",
  isVegetarian: "è vegetariano",
  containsLupin: "Contiene lupino",
  containsCelery: "Contiene sedano",
  containsPeanuts: "Contiene arachidi",
  containsCrustacean: "Contiene crostacei",
  containsGluten: "Contiene glutine",
  containsEgg: "Contiene uovo",
  containsMilk: "Contiene latte",
  containsMustard: "Contiene senape",
  containsFish: "Contiene pesce",
  containsSesame: "Contiene sesamo",
  containsSoy: "Contiene soia",
  containsSulfite: "Contiene solfito",
  vegetarian: "Vegetariano",
  allergens: "ALLERGENI:",
  lupins: "lupini",
  celery: "Sedano",
  peanuts: "Arachidi",
  crustaceans: "crostacei",
  gluten: "Glutine",
  egg: "Uovo",
  dairyProducts: "Latticini",
  mustard: "Mostarda",
  fish: "Pesce",
  sesame: "Sesamo",
  soy: "Soia",
  sulfite: "solfito",
  findProduct: "Trova prodotto"
};
